function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Box, Button, Heading, Layer, Text } from 'grommet';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
const StyledLayer = styled(Layer)`
  z-index: 1001;
`;
const CookiesDialog = ({
  isVisible,
  onAccept,
  onReject,
  ...rest
}) => {
  return isVisible && /*#__PURE__*/React.createElement(StyledLayer, _extends({
    margin: "xsmall",
    modal: false,
    position: "bottom"
  }, rest), /*#__PURE__*/React.createElement(Box, {
    border: true,
    justify: "center",
    gap: "xxsmall",
    pad: "medium",
    width: "100"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    margin: "none"
  }, "Cookies"), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "This site uses cookies to offer you a better browsing experience. Find out more on", /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    margin: "xsmall"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/privacy-policy"
  }, "how we use cookies and how you can change your settings."))), /*#__PURE__*/React.createElement(Box, {
    gap: "xsmall",
    direction: "row",
    align: "center",
    justify: "end",
    margin: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    label: /*#__PURE__*/React.createElement(Text, {
      color: "brand",
      size: "small"
    }, "I accept cookies"),
    onClick: onAccept
  }), /*#__PURE__*/React.createElement(Button, {
    label: /*#__PURE__*/React.createElement(Text, {
      color: "brand",
      size: "small"
    }, "I reject cookies"),
    onClick: onReject
  }))));
};
CookiesDialog.defaultProps = {
  isVisible: false,
  onAccept: () => {},
  onReject: () => {}
};
CookiesDialog.propTypes = {
  isVisible: PropTypes.bool,
  onAccept: PropTypes.func,
  onReject: PropTypes.func
};
export default CookiesDialog;